import { Component, EventEmitter, HostListener, Input, Output } from "@angular/core";

@Component({
  selector: 'app-primary-button',
  templateUrl: './primary-button.component.html',
  styleUrls: ['../styles.css', './primary-button.component.css']
})
export class PrimaryButtonComponent {
  @Input() isDisabled: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() buttonId: string = '';
  @Input() type: string = ''
  @Output() handleClick = new EventEmitter();
  @Output() handleKeypressEnter = new EventEmitter();

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if(event.key === "Enter"){
      this.handleKeypressEnter.emit();
    }
  }
}
